

import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, TEXT_AREA, NUMBER ,TIME} = FIELD_TYPE;

const dataFields: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày phỏng vấn",
    name: "ngayPhongVan",
    disable: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    disableDate:false,

  },
  {
    type: TIME,
    name: "gioPhongVan",
    label: "Giờ phỏng vấn",
    disable: false,
    optionsTime: {
      showTime: true,
      format: 'HH:mm'
    },

  },
  {
    type: TEXT_AREA,
    name: "ghiChuLichPhongVan",
    label: "Ghi chú",
    disable: false,
    css: {
      xl: 16,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },

  },


];
export {dataFields};

